import { mainSiteUrl } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

export default function ArticleSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl">
          <p className="text-xs font-medium text-accent-600 uppercase tracking-widest mb-3">Latest Guide</p>

          <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-medium text-foreground-900 leading-tight">
              The Ultimate
            </h2>
            <span className="inline-block w-12 h-8 md:w-14 md:h-9 rounded-full overflow-hidden align-middle">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20extreme%20closeup%20of%20a%20premium%20suede%20sneaker%20toe%20box%20on%20cream%20background%2C%20soft%20directional%20lighting%2C%20minimalist%20product%20photography%20showing%20fine%20material%20texture&width=120&height=80&seq=inline-v2-shoe&orientation=landscape"
                alt="CSSBuy Sheet sneaker closeup"
                className="w-full h-full object-cover"
              />
            </span>
          </div>

          <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mt-0.5">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-medium text-foreground-900 leading-tight">
              CSSBuy Sheet
            </h2>
            <span className="inline-block w-12 h-8 md:w-14 md:h-9 rounded-full overflow-hidden align-middle">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20closeup%20of%20a%20classic%20wristwatch%20with%20brown%20leather%20strap%20on%20cream%20linen%2C%20soft%20morning%20light%2C%20editorial%20product%20photography%2C%20warm%20neutral%20palette&width=120&height=80&seq=inline-v2-watch&orientation=landscape"
                alt="CSSBuy Sheet accessory"
                className="w-full h-full object-cover"
              />
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-medium text-foreground-900 leading-tight mt-0.5">
            Guide for 2026
          </h2>

          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
            Discover the most curated and up-to-date <strong className="text-foreground-800">CSSBuy spreadsheet</strong> for every category — from sneakers and streetwear to luxury accessories. Our team reviews and refreshes links weekly so you get accurate prices, trusted sellers, and real buyer feedback in one place. Whether you are a first-time user or a seasoned haul veteran, this guide helps you shop smarter and ship cheaper through CSSBuy in 2026.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3 mt-8">
            <button
              onClick={() => navigate('/cssbuy-sheet-guide')}
              className="inline-flex items-center px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Read CSSBuy Guide
              <span className="w-4 h-4 flex items-center justify-center ml-1.5">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </button>
            <button
              onClick={() => navigate('/cssbuy-sheet-shopping-guide')}
              className="inline-flex items-center px-6 py-3 rounded-full bg-transparent text-accent-600 border border-accent-400 text-sm font-medium hover:bg-accent-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Shopping Tips
              <span className="w-4 h-4 flex items-center justify-center ml-1.5">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}